var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgM1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg3776",
    width: "63.596mm",
    height: "41.897mm",
    viewBox: "0 0 63.596 41.897",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-184.24 -125.69)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect111-9",
    d: "m185.43 125.69c-0.66061 0-1.1926 0.62279-1.1926 1.3965v39.104c0 0.7737 0.53196 1.3965 1.1926 1.3965h61.211c0.66061 0 1.1924-0.62279 1.1924-1.3965v-39.104c0-0.7737-0.53175-1.3965-1.1924-1.3965zm0.59607 1.1639h60.019c0.44041 0 0.79491 0.41519 0.79491 0.931v37.707c0 0.51581-0.3545 0.93124-0.79491 0.93124h-60.019c-0.4404 0-0.7949-0.41543-0.7949-0.93124v-37.707c0-0.51581 0.3545-0.931 0.7949-0.931z",
    fill: "#999",
    strokeWidth: 0.9105
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-1",
    x: 185.83,
    y: 127.6,
    width: 60.417,
    height: 2.7462,
    rx: 0.59039,
    fill: "#ccc",
    strokeWidth: 0.6216
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-2",
    x: 185.83,
    y: 162.95,
    width: 60.417,
    height: 2.7462,
    rx: 0.59039,
    fill: "#ccc",
    strokeWidth: 0.6216
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-7",
    x: 185.83,
    y: 131.08,
    width: 12.306,
    height: 15.121,
    rx: 0.52869,
    fill: "#ccc",
    strokeWidth: 0.65829
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-5-0",
    x: 185.83,
    y: 147.03,
    width: 12.306,
    height: 15.121,
    rx: 0.52869,
    fill: "#ccc",
    strokeWidth: 0.65829
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-6-9",
    x: 198.77,
    y: 131.08,
    width: 34.198,
    height: 22.529,
    rx: 0.59622,
    fill: "#666",
    strokeWidth: 1.3395
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-5-2-3",
    x: 198.77,
    y: 154.47,
    width: 34.166,
    height: 7.6849,
    rx: 0.61268,
    fill: "#ccc",
    strokeWidth: 0.78195
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-3-6",
    x: 233.94,
    y: 131.08,
    width: 12.306,
    height: 15.121,
    rx: 0.52869,
    fill: "#ccc",
    strokeWidth: 0.65829
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect1190-6-7-5-5-0",
    x: 233.94,
    y: 147.03,
    width: 12.306,
    height: 15.121,
    rx: 0.52869,
    fill: "#ccc",
    strokeWidth: 0.65829
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM1);
export default __webpack_public_path__ + "static/media/m1.a0c8e13f600a2ba71c372534c58465bc.svg";
export { ForwardRef as ReactComponent };